import React from 'react';

import Modal from 'Components-redesign/Modal';
import ModalContentWrapper from 'Components-redesign/Modal/ModalContentWrapper';

import { ModalContent } from './styles';

const TermsAndConditions = ({ isShowing = false, hide }) => {
  return (
    <Modal isShowing={isShowing} hide={hide} showCloseBtn={true}>
      <ModalContentWrapper width="700px">
        <ModalContent>
          <div>
            <h2>Allmänna villkor</h2>
            <br />
            <h4>Beskrivning av tjänst</h4>
            <p>
              Kund ingår avtal med Min Go AB avseende tillgång till applikationens system, där
              restaurangen kan hantera sina menyer med priser samt bedriva försäljning genom separat
              betalningslösning.
            </p>
            <p>
              Leverantören ansvarar för att leveranser genomförs på ett professionellt sätt efter
              god affärssed. Detta avtal tjänar som parternas avtal för aktuella och kommande
              beställningar. Beställningar ska göras skriftligen. Förändringar av innehåll i detta
              avtal krävs skriftlig begäran.
            </p>

            <h4>Licens</h4>
            <p>
              36 månaders bindningstid där avtalet löper fr o m 2021-12-01 t o m 2024-12-01. För
              uppsägning innan avtalsperiodens slut gäller en ömsesidig uppsägningstid om 6 månader
              under avtalstiden för båda parterna. Skriftlig uppsägning krävs. Min Go förbehåller
              sig rätten att indexjustera priset för licenser med 5% årsvis för att följa
              kostnadsutvecklingen inom branschen utan skriftligt meddelande till kund.
            </p>

            <h4>Licens</h4>
            <p>
              Enl ramavtal mellan Min Go AB och The True Bröderna Brothers AB.
              <br />
              Skriftlig uppsägning krävs.
            </p>

            <h4>Onboarding</h4>
            <p>
              Baemingo tillhandahåller Kund överenskomna tjänster från och med avtalad startdag,
              genom att Baemingo förser Kund med inloggningsuppgifter och/eller eventuella andra
              anvisningar. Startdagen inträder vid ovanstående tillfälle utan krav på något särskilt
              godkännande från Kund. I onboarding ingår hjälp med uppsättning av menyer,
              konfiguration av säljkanaler, stationer och kringliggande system/integrationer som
              ingår i leveransen som t.ex. FortNox och Personalkollen. Det är kundens ansvar att
              förse Baemingo med information och data enligt instruktion från onboardingansvarig
              Utbildning av ansvariga på restaurangen ingår även i onboarding, därefter är
              restaurangen ansvarig för att vidareutbilda intern personal i Baemingos system.
              <br />
              Inkluderad tid för er onboarding är 3 timmar. Kund ansvarar för att avsätta tid och
              vara redo inför uppstart och aktivering enligt instruktioner från Baemingo. Start för
              fakturering sker på startdagen och fortlöper även om Kund av någon anledning inte
              prioriterar eller avsätter tid för planerad onboarding.
            </p>

            <h4>Installation</h4>
            <p>
              Installation av hårdvara utförs av egen tillhandahållen installatör eller av Baemingos
              installationspartner på bekostnad av Kund. Baemingo kan vid behov bistå med
              koordinering av arbetet med installationspartners.
            </p>

            <h4>Betalning</h4>
            <p>
              Om inget annat anges i Användarvillkoren följer avgifter och faktureringsperioder för
              Tjänsten de priser som vid var tidpunkt görs tillgängliga av Baemingo. Betalning för
              licenser till Baemingo sker månadsvis i förskott. 30 dagar netto med dröjsmålsränta 8
              %. Exempel: februari månads licens betalas i januari. Vid utebliven betalning äger
              Baemingo rätt att pausa åtkomst till systemet tills dess att betalning fullgjorts
              enligt avtal
            </p>

            <h4> Nätverk och internet</h4>
            <p>
              Kund ansvarar för att nätverk och el finns förberett och fungerande i restaurangen för
              den att täcka den planerade produktionsytan för tjänsten Baemingo tillhandahåller.
              Baemingo ansvarar inte för produkter eller tjänster från tredjepartsleverantörer för
              nätverk och internet.
            </p>

            <h4>Hårdvara</h4>
            <p>
              Baemingo äger inget ansvar för hårdvara, men är dock behjälpliga att det avtalas
              mellan kund och tredjepart eller ombesörja hantering av extra, ny eller ersättning av
              trasig hårdvara. För förmedling av ny, trasig eller försvinner hårdvara utgår en
              administrationsavgift om 500kr.
            </p>

            <h4>Jour utryckning</h4>
            <p>
              Vid tillfällen där jourpersonal från Baemingo begärs komma ut till restaurang mellan
              kl18:00-03:00 på vardag eller helgtid (lör-sön eller annan röd dag) för en
              ärendehantering utgår ersättning om 1 500kr. Ersättning utgår dock inte under vardagar
              Mån-fre mellan kl08:00-18:00 då jourpersonal kommer ut på plats.
            </p>

            <h4>Immateriella rättigheter</h4>
            <p>
              Samtliga rättigheter till av Leverantören utförda prestationer enligt detta avtal,
              omfattande i förekommande fall original, texter och data tillfaller exklusivt
              uppdragsgivaren efter att avtalsenlig ersättning för prestationens utförande erlagts
              till Leverantören.
            </p>

            <h4>Force Majeure</h4>
            <p>
              Part är befriad från påföljd för underlåtenhet att fullgöra avtalad leverans enligt
              detta avtal, om underlåtenheten har sin grund i omständighet av det slag som anges
              nedan ("befriande omständighet") och omständigheten förhindrar, avsevärt försvårar
              eller försenar fullgörande därav. Såsom befriande omständighet skall anses bl. a.
              myndighetsåtgärd eller underlåtenhet, nytillkommen eller ändrad lagstiftning, konflikt
              på arbetsmarknaden, brand, översvämning eller olyckshändelse av större omfattning.
              Part som påkallar befrielse enligt bestämmelserna ovan skall utan dröjsmål underrätta
              andra parten därom. Oavsett vad ovan anges om befrielse från påföljd äger endera
              parten rätten att säga upp avtalet till omedelbart upphörande om fullgörande av
              leveransen försenas på̊ grund av Force majeure med mer än tre månader.
            </p>

            <h4>Sekretessförbindelse</h4>
            <p>
              Leverantören förbinder sig härmed att inte utan uppdragsgivarens medgivande till
              tredje man under avtalets – och giltighetstiden för eventuella underavtal,
              uppdragsavtal med mera utlämna sådana uppgifter om uppdragsgivarens verksamhet som kan
              vara att betrakta som affärs- eller yrkeshemlighet. Sekretesskyldighet gäller inte
              sådan information som part kan visa blivit känd för honom på̊ annat sätt än genom
              uppdraget eller som är allmänt känd.
            </p>
          </div>
        </ModalContent>
      </ModalContentWrapper>
    </Modal>
  );
};

export default TermsAndConditions;
